// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"299":"5bc6d13a","488":"206b81e6"}[chunkId] + ".chunk.js";
};